import { Fade, styled, useTheme } from "@mui/material";
import { hoverStyles } from "helpers/hoverStyles";
import { Link } from "react-router-dom";
import { Route } from "routes";
const PREFIX = "BreadcrumbItem";

const classes = {
	root: `${PREFIX}-root`,
};

const StyledLink = styled(Link)(({ theme }) => ({
	[`&.${classes.root}`]: {
		borderRadius: theme.shape.borderRadius,
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
		textDecoration: "none",
		fontWeight: "bold",
		fontSize: "2rem",
		color: "white",
		whiteSpace: "nowrap",
		"&:hover": {
			textDecoration: "none",
		},
	},
}));

export interface BreadcrumbItemProps {
	route: Route;
}

export const BreadcrumbItem = ({
	route: { name, path },
}: BreadcrumbItemProps): JSX.Element => {
	const theme = useTheme();

	return (
		<Fade in>
			<StyledLink sx={hoverStyles(theme)} className={classes.root} to={path}>
				{name}
			</StyledLink>
		</Fade>
	);
};
